import { LoadingRows } from "../UI/Loading/LoadingRows.tsx";
import { useFranchiseeById } from "./useFranchiseeById.ts";
import { Layout } from "../UI/Layout/Layout.tsx";
import { ScreenTitleBlock } from "../UI/Layout/ScreenTitleBlock.tsx";
import { FranchiseeForm, FranchiseeFormInputs } from "./FranchiseeForm.tsx";
import { BreadCrumbsWrapper } from "../UI/Layout/BreadCrumbsWrapper.tsx";
import { BreadCrumbsItem } from "../UI/Layout/BreadCrumbsItem.tsx";
import { useToAllFranchisees } from "./useToAllFranchisees.ts";
import { useFranchiseeIdParamsOrThrow } from "./useFranchiseeIdParamsOrThrow.ts";
import { useUpdateTeacher } from "./useUpdateTeacher.ts";
import { Card } from "../UI/Card.tsx";
import { TeacherRole } from "../gql/graphql.ts";

export const EditFranchiseeScreenPath = "/franchisees/:franchiseeId/edit";
export function EditFranchiseeScreen() {
  const { franchiseeId } = useFranchiseeIdParamsOrThrow();
  const { franchisee, loading } = useFranchiseeById(franchiseeId);
  const { toAllFranchisees } = useToAllFranchisees();
  const { updateTeacher } = useUpdateTeacher();

  async function update(f: FranchiseeFormInputs): Promise<void> {
    await updateTeacher({
      id: franchiseeId,
      phoneNumber: f.phoneNumber,
      userGroupIds: f.userGroupIds,
      lesson1on1: f.lesson1on1,
      roles: f.roles,
      tags: f.tags,
    });
    toAllFranchisees();
  }

  return (
    <Layout>
      <Card>
        <ScreenTitleBlock
          breadCrumbs={
            <BreadCrumbsWrapper>
              <BreadCrumbsItem onClick={toAllFranchisees} title={"Teachers"} />
              <BreadCrumbsItem title={"Edit teacher"} />
            </BreadCrumbsWrapper>
          }
          title={`Edit teacher`}
        />
      </Card>
      <div className={"mt-4"}>
        <Card>
          {loading ? (
            <LoadingRows rows={6} />
          ) : (
            <FranchiseeForm
              disabledMap={{
                givenName: true,
                familyName: true,
                email: true,
              }}
              onSave={update}
              showInternalTeacher={false}
              defaultValues={{
                givenName: franchisee?.givenName ?? "",
                familyName: franchisee?.familyName ?? "",
                email: franchisee?.email ?? "",
                phoneNumber: {
                  countryCode: franchisee?.phoneNumber?.countryCode ?? "+39",
                  number: franchisee?.phoneNumber?.number ?? "",
                },
                userGroupIds: franchisee?.userGroupIds ?? undefined,
                lesson1on1: franchisee?.lesson1on1 ?? false,
                roles: franchisee?.roles ?? [TeacherRole.Teacher],
                tags: franchisee?.tags ?? [],
              }}
            />
          )}
        </Card>
      </div>
    </Layout>
  );
}
